import clsx from "clsx"
import React, { PropsWithChildren } from "react"
import { createUseStyles } from "react-jss"
import { PropsWithClassName } from "utils/types"

const useStyles = createUseStyles(theme => ({
  root: {
    background: "#fff",
    border: `1px solid ${theme.colors.onSurface[200]}`,
    borderRadius: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      borderRadius: 0,
    },
  },
}))

const Section = ({
  id,
  children,
  className,
}: PropsWithChildren<PropsWithClassName<{ id?: string }>>) => {
  const classes = useStyles()
  return (
    <section id={id} className={clsx(classes.root, className)}>
      {children}
    </section>
  )
}

export default Section
